import { render, staticRenderFns } from "./usePower.vue?vue&type=template&id=0150c727&"
import script from "./usePower.vue?vue&type=script&lang=js&"
export * from "./usePower.vue?vue&type=script&lang=js&"
import style0 from "./usePower.vue?vue&type=style&index=0&id=0150c727&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports